import React, { useMemo } from 'react';
import { useLocation } from 'react-router';
import { useTranslation } from 'react-i18next';
import { useAppRole } from '../../../app/routes/useRolePath';
import { routesByRole } from '../../../app/routes/routes.config';
import { AppRoute } from '../../../app/routes/routes.types';
import { roles } from '../../../app/routes/paths';
import { FaBeer } from 'react-icons/fa';

const mapNavChildren = (
  children: AppRoute[] | undefined,
  parentIndex: number,
  pathname: string,
  t: (key: string) => string,
) =>
  (children || [])
    .filter(child => child.pageTitle && child.isInNavigation !== false)
    .map((child, childIndex) => ({
      id: `${parentIndex}-${childIndex}`,
      title: t(child.pageTitle!),
      path: child.route || '',
      pathKey: child.pathKey || '',
      isActive: child.isActive ? child.isActive(pathname) : undefined,
      icon: child.renderIcon ? child.renderIcon(pathname, false) : undefined,
      children: [],
      type: child.pathKey || '',
    }));

const useLinks = () => {
  const { t } = useTranslation();
  const userRole = useAppRole();
  const location = useLocation();

  const links = useMemo(() => {
    if (userRole === roles.NONE) {
      return [];
    }

    return (routesByRole[userRole] || [])
      .filter(route => route.pageTitle && route.isInNavigation !== false)
      .map((route, index) => ({
        id: index,
        title: t(route.pageTitle!),
        path: route.route || '',
        pathKey: route.pathKey || '',
        className: route.className || '',
        isActive: route.isActive
          ? route.isActive(location.pathname)
          : undefined,
        icon: route.renderIcon ? (
          route.renderIcon(location.pathname, false)
        ) : (
          <FaBeer />
        ),
        count: 0,
        children: mapNavChildren(
          route.children,
          index,
          location.pathname,
          t,
        ),
        type: route.pathKey || route.route?.split('/')[1] || '',
      }));
  }, [location.pathname, userRole, t]);

  return links;
};

export default useLinks;
